export default __webpack_public_path__ + "src/assets/icn-address-book.8daba5571f7fafe52947572adcf8ab7f.svg";